<button [ngClass]="{'mobile-navbar-button': true, 'toggled': isToggled}" (click)="toggleNav()">
    <!--<span></span>-->
    <i class="icon-menu"></i>
</button>
